import { $tag, TaggedEnumUnion, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

import { $GradeLevel, GradeLevel } from './grade-level';

const $ = 'SkillSetLevel';

export const SkillSetLevel = {
  SS1: tagEnum($, 1),
  SS2: tagEnum($, 2),
  SS3: tagEnum($, 3),
  SS4: tagEnum($, 4),
  SS5: tagEnum($, 5),
  SS6: tagEnum($, 6),
  SS7: tagEnum($, 7),
  SS8: tagEnum($, 8),
} as const;

export type SkillSetLevel = TaggedEnumUnion<typeof SkillSetLevel>;

export const $SkillSetLevel = buildStaticContext({
  [$tag]: $,
  [SkillSetLevel.SS1]: {
    value: SkillSetLevel.SS1,
    slug: 'ss-1',
    label: 'Skill Set 1',
    color: $GradeLevel.describe(GradeLevel.Level1).color,
    skills: ['Add', 'Subtract', 'Add or subtract'],
  },
  [SkillSetLevel.SS2]: {
    value: SkillSetLevel.SS2,
    slug: 'ss-2',
    label: 'Skill Set 2',
    color: $GradeLevel.describe(GradeLevel.Level2).color,
    skills: [
      'Choose add or subtract',
      'Add/Subtract\nTwo-step solution',
      'Add/Subtract\nMake 24',
    ],
  },
  [SkillSetLevel.SS3]: {
    value: SkillSetLevel.SS3,
    slug: 'ss-3',
    label: 'Skill Set 3',
    color: $GradeLevel.describe(GradeLevel.Level3).color,
    skills: ['Multiply', 'Divide', 'All four operations'],
  },
  [SkillSetLevel.SS4]: {
    value: SkillSetLevel.SS4,
    slug: 'ss-4',
    label: 'Skill Set 4',
    color: $GradeLevel.describe(GradeLevel.Level4).color,
    skills: [
      'All four operations\nTwo-step solution',
      'All four operations\nTwo-step, make 24',
      'All four operations\nMulti-step solution',
    ],
  },
  [SkillSetLevel.SS5]: {
    value: SkillSetLevel.SS5,
    slug: 'ss-5',
    label: 'Skill Set 5',
    color: $GradeLevel.describe(GradeLevel.Level5).color,
    skills: [
      'Fractions\nAdd/subtract',
      'Double digits',
      'Decimals\nOne or two steps',
    ],
  },
  [SkillSetLevel.SS6]: {
    value: SkillSetLevel.SS6,
    slug: 'ss-6',
    label: 'Skill Set 6',
    color: $GradeLevel.describe(GradeLevel.Level6).color,
    skills: [
      'Decimals',
      'Variables',
      'Fractions\nAll four operations\nOne or two steps',
    ],
  },
  [SkillSetLevel.SS7]: {
    value: SkillSetLevel.SS7,
    slug: 'ss-7',
    label: 'Skill Set 7',
    color: $GradeLevel.describe(GradeLevel.Level7).color,
    skills: ['Fractions', 'Integers', 'Algebra\nBasic'],
  },
  [SkillSetLevel.SS8]: {
    value: SkillSetLevel.SS8,
    slug: 'ss-8',
    label: 'Skill Set 8',
    color: $GradeLevel.describe(GradeLevel.Level8).color,
    skills: ['Exponents', 'Algebra\nIntermediate', 'Algebra\nAdvanced'],
  },
} as const);
